import { render, staticRenderFns } from "./AuditRecordList.vue?vue&type=template&id=4a965984&scoped=true"
import script from "./AuditRecordList.vue?vue&type=script&lang=js"
export * from "./AuditRecordList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a965984",
  null
  
)

export default component.exports